import { createSlice } from "@reduxjs/toolkit";
import { generateAcquirerReport } from "./PeriodicAcquirerReport.thunk";

const baseState = {
  status: "idle",
  error: null,
  retryCount: 0,
  isos: [],
  consolidatedData: null,
  acquirerID: null,
  acquirerName: null,
};

const initialState = {
  ...baseState,
};

export const periodicAcquirerReportSlice = createSlice({
  name: "periodicAcquirerReport",
  initialState,
  reducers: {
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateAcquirerReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(generateAcquirerReport.fulfilled, (state, action) => {
        const {
          retryCount,
          isos,
          consolidatedData,
          acquirerID,
          acquirerName,
        } = action.payload;
        state.retryCount = retryCount;
        state.isos = isos ?? [];
        state.consolidatedData = consolidatedData;
        state.acquirerID = acquirerID;
        state.acquirerName = acquirerName;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(generateAcquirerReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error generating report";
      });
  },
});

export const { ResetStore } = periodicAcquirerReportSlice.actions;

export default periodicAcquirerReportSlice.reducer;
